<template>
  <NewStudioModalsModalShell class="share-modal" title="Share Design" data-figma-node="2909:175995" @close="$emit('close')">
    <label class="sr-only" for="new-share-link">Share link</label>
    <div class="share-row">
      <input id="new-share-link" ref="input" :value="shareLink" readonly>
      <button class="copy-icon" type="button" aria-label="Copy share link" @click="copy"><img src="/new-studio/icons/copy.svg" alt=""></button>
    </div>
    <button class="copy-action" type="button" aria-label="Load Design — copy share link" @click="copy">Load Design</button>
    <p v-if="message" :class="{ error: !copied }" :role="copied ? 'status' : 'alert'">{{ message }}</p>
  </NewStudioModalsModalShell>
</template>

<script setup lang="ts">
import { copyTextWithFallback } from '../logic'
defineEmits<{ close: [] }>()
const projectStore = useProjectStore()
const input = useTemplateRef<HTMLInputElement>('input')
const copied = ref(false)
const message = ref('')
const shareLink = computed(() => `${window.location.origin}/?import=${projectStore.designId}`)
const copy = async () => {
  copied.value = await copyTextWithFallback(shareLink.value)
  message.value = copied.value ? 'Share link copied to clipboard.' : 'Unable to copy share link. Please try again.'
  if (copied.value) input.value?.select()
}
</script>

<style scoped>
.sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0,0,0,0); }
.share-row { position: relative; margin-top: 17.95px; }
input { box-sizing: border-box; width: 100%; height: 50px; padding: 0 54px 0 18px; border: 2px solid #d9d8d3; font: inherit; font-size: 17.95px; font-weight: 600; }
.copy-icon { position: absolute; top: 0; right: 5px; display: grid; width: 45px; height: 50px; padding: 0; place-items: center; border: 0; background: transparent; cursor: pointer; }
.copy-icon img { width: 27px; height: 27px; }
.copy-action { width: 100%; min-height: 52px; margin-top: 17.95px; border: 0; background: #2e3a46; color: #fff; font: inherit; font-size: 16.155px; font-weight: 700; cursor: pointer; }
p[role] { margin: 8px 0 0; color: #246b2d; font-size: 12px; }
p.error { color: #a32121; }
:global(.share-modal > h2) { margin-top: 17.95px; text-align: left; font-size: 34.105px; letter-spacing: -.341px; }
:global(.share-modal) { box-sizing: border-box; height: 276px; }
</style>
